import { z } from "zod";

export const submissionVerificationStatusValue = [
  "pending",
  "passed",
  "approved",
  "flagged",
  "error",
  "skipped",
  "rejected",
] as const;

export type SubmissionVerificationStatus =
  (typeof submissionVerificationStatusValue)[number];

export const submissionVerificationStatusSchema = z.enum(
  submissionVerificationStatusValue,
);

export const submissionVerificationOutcomeValue = [
  "passed",
  "flagged",
] as const;

export type SubmissionVerificationOutcome =
  (typeof submissionVerificationOutcomeValue)[number];

export const submissionVerificationOutcomeSchema = z.enum(
  submissionVerificationOutcomeValue,
);

export const submissionCheckerOutcomeValue = [
  "passed",
  "failed",
  "skipped",
] as const;

export type SubmissionCheckerOutcome =
  (typeof submissionCheckerOutcomeValue)[number];

export const submissionCheckerOutcomeSchema = z.enum(
  submissionCheckerOutcomeValue,
);

export type SubmissionCheckerResult = {
  checkerId: string;
  outcome: SubmissionCheckerOutcome;
  confidence?: number;
  weight?: number;
  reason?: string;
};
